import { generateHeatmapData } from 'src/utils/util';

const startDate = new Date('2025-05-17T00:00:00');
const endDate = new Date('2025-05-21T00:00:00');
const intervalHours = 1;

const heatmapChart = {
  series: [
    {
      name: 'Product A',
      data: generateHeatmapData(startDate, endDate, intervalHours, -2.0, 2.0),
    },
    {
      name: 'Product B',
      data: generateHeatmapData(startDate, endDate, intervalHours, -2.0, 1.3),
    },
  ],

  options: {
    chart: {
      width: '100%',
      height: 350,
      type: 'heatmap',
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: false,
      },
    },

    legend: {
      show: true,
    },

    dataLabels: {
      enabled: true,
      // formatter: function (val) {
      //   return val.toFixed(1)
      // },
      style: {
        fontSize: '10px',
        fontWeight: 600,
      },
    },

    yaxis: {
      labels: {
        style: {
          fontSize: '10px',
          fontWeight: 600,
        },
      },
    },

    plotOptions: {
      heatmap: {
        reverseNegativeShade: true,
        colorScale: {
          ranges: [
            {
              from: -10,
              to: 0,
              color: '#ffccc7',
              name: 'loss',
            },
            {
              from: 0,
              to: 10,
              color: '#1677ff',
              name: 'profit',
            },
          ],
        },
      },
    },

    xaxis: {
      type: 'datetime',
      labels: {
        datetimeFormatter: {
          year: 'yyyy',
          month: 'MMM yyyy',
          day: 'MM/dd',
          hour: 'HH:mm',
        },
      },
    },

    tooltip: {
      x: {
        format: 'yyyy-MM-dd HH:mm',
      },
      y: {
        formatter: function (val) {
          return `${val}%`;
        },
      },
    },
  },
};

export default heatmapChart;
